<template>
  <div class="popup-form">
    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">Schválenie žiadosti</div>
        <button class="w-button saveformBtn" @click="saveStatus">Aktualizovať</button>
      </div>
      
      <!-- <div class="input-group">
        <label class="field-label">Kedy bola žiadosť schválená</label>
        <input
          name="dateOfUpload"
          type="date"
          :max="todayLong"
          class="text-input w-input date-input"
          maxlength="256"
        />
      </div> -->
      <div class="splitter">Potvrďte alebo aktualizujte podmienky schválenia</div>
      <div class="input-group">
        <label for="urok" class="field-label">Požadovaná sadzba</label
        ><input
        v-model.number="formData.sadzba_pozadovana"
        type="number"
        readonly="readonly"
        class="text-input w-input"
        maxlength="256"
        min="1"
        step=".01"
        name="urok"
        id="urok"
      />
      </div>
      <div class="input-group">
        <label for="urok" class="field-label">Schválená sadzba</label
        ><input
        v-model.number="formData.sadzba_schvalena"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        step=".01"
        name="urok"
        id="urok"
      />
      </div>
      <div class="input-group">
        <label for="fixacia" class="field-label">Fixácia<strong></strong></label
        ><input
        v-model.number="formData.fix"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        name="fixacia"
        id="fixacia"
      />
      </div>
      <div class="input-group">
        <label for="vyskauveru" class="field-label">Výška úveru nadobudnutie<strong></strong></label
        ><input
        v-model.number="formData.suma_nadobudnutie"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        name="vyskauveru"
        id="vyskauveru"
      />
      </div>
      <div class="input-group">
        <label for="vyskauveru" class="field-label">Výška úveru refinancovanie<strong></strong></label
        ><input
        v-model.number="formData.suma_refinancovanie"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        name="vyskauveru"
        id="vyskauveru"
      />
      </div>
      <div class="input-group">
        <label for="vyskauveru" class="field-label">Výška úveru bezúčel<strong></strong></label
        ><input
        v-model.number="formData.suma_bezucel"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        name="vyskauveru"
        id="vyskauveru"
      />
      </div>
      <div class="input-group">
        <label for="splatka" class="field-label">Splátka<strong></strong></label
        ><input
        v-model.number="formData.splatka"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        step=".01"
        @input="paymentManuallyEdited = true"
        name="splatka"
        id="splatka"
      />
        <div class="input-hint">
          Po zmene sumy, sadzby alebo splatnosti sa vypočíta automaticky. Hodnotu môžete upraviť podľa rozhodnutia banky.
        </div>
      </div>
      <div class="input-group">
        <label for="splatnost" class="field-label">Poplatok<strong></strong></label
        ><input
        v-model="formData.poplatok_za_poskytnutie"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        name="poplatok_za_poskytnutie"
        id="poplatok_za_poskytnutie"
      />
      </div>
      <div class="input-group">
        <label for="splatnost" class="field-label">Splatnosť<strong></strong></label
        ><input
        v-model.number="formData.splatnost"
        type="number"
        class="text-input w-input"
        maxlength="256"
        min="1"
        name="splatnost"
        id="splatnost"
      />
      </div>
    </div>
  </div>
</template>

<script>
import {calculateMortgagePayment} from "@/services/brokerService";

export default {
  name: "MortgageApplicationApprovalPopup",
  props: {
    payload: Object,
  },
  created() {
    this.formData.sadzba_pozadovana = this.payload.sadzba_pozadovana;
    this.formData.sadzba_schvalena = this.payload.sadzba_schvalena;
    this.formData.fix = this.payload.fix;
    this.formData.suma_nadobudnutie = this.payload.suma_nadobudnutie;
    this.formData.suma_refinancovanie = this.payload.suma_refinancovanie;
    this.formData.suma_bezucel = this.payload.suma_bezucel;
    this.formData.splatnost = this.payload.splatnost;
    this.formData.splatka = this.payload.splatka;
    this.formData.poplatok_za_poskytnutie = this.payload.poplatok_za_poskytnutie;
    this.$nextTick(this.queuePaymentCalculation);
  },
  watch: {
    "formData.sadzba_schvalena": "queuePaymentCalculation",
    "formData.suma_nadobudnutie": "queuePaymentCalculation",
    "formData.suma_refinancovanie": "queuePaymentCalculation",
    "formData.suma_bezucel": "queuePaymentCalculation",
    "formData.splatnost": "queuePaymentCalculation",
  },
  methods: {
    queuePaymentCalculation () {
      this.paymentManuallyEdited = false;
      this.recalculatePayment();
      clearTimeout(this.paymentTimer);
      this.paymentTimer = setTimeout(this.verifyPaymentOnServer, 250);
    },
    recalculatePayment () {
      const principal = [
        this.formData.suma_nadobudnutie,
        this.formData.suma_refinancovanie,
        this.formData.suma_bezucel,
      ].reduce((sum, value) => sum + (Number(value) || 0), 0);
      const annualRate = Number(this.formData.sadzba_schvalena);
      const months = Math.round((Number(this.formData.splatnost) || 0) * 12);

      if (!(principal > 0) || !Number.isFinite(annualRate) || months <= 0) return;
      const monthlyRate = annualRate / 100 / 12;
      const payment = monthlyRate === 0
        ? principal / months
        : principal * monthlyRate / (1 - Math.pow(1 + monthlyRate, -months));
      this.formData.splatka = Number(payment.toFixed(2));
    },
    async verifyPaymentOnServer () {
      const principal = [
        this.formData.suma_nadobudnutie,
        this.formData.suma_refinancovanie,
        this.formData.suma_bezucel,
      ].reduce((sum, value) => sum + (Number(value) || 0), 0);
      const annualRate = Number(this.formData.sadzba_schvalena);
      const months = Math.round((Number(this.formData.splatnost) || 0) * 12);
      if (!(principal > 0) || !Number.isFinite(annualRate) || months <= 0) return;

      const requestId = ++this.paymentRequestId;
      try {
        const result = await calculateMortgagePayment({
          suma: principal.toFixed(2),
          sadzba: annualRate.toFixed(2),
          splatnost_mesiace: months,
        });
        if (requestId === this.paymentRequestId && !this.paymentManuallyEdited) {
          this.formData.splatka = Number(result.splatka);
        }
      } catch (_) {
        // Okamžitý výpočet v modale ostáva dostupný aj pri krátkom výpadku API.
      }
    },
    saveStatus () {
      this.$store.commit("popupManagerState/setPopupSuccessResult", {status: true, form: this.formData, stage: "schvalena"});
      this.preverDestroy = true;
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    closePopup () {
      this.$store.commit("popupManagerState/setPopupSuccessResult", {status: false});
      this.preverDestroy = true;
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  beforeDestroy () {
    clearTimeout(this.paymentTimer);
    if (this.preverDestroy) return;
    this.$store.commit("popupManagerState/setPopupSuccessResult", {status: false});
  },
  data: () => ({
    preverDestroy: false,
    todayLong: new Date().toISOString().substr(0, 10),
    paymentTimer: null,
    paymentRequestId: 0,
    paymentManuallyEdited: false,
    formData: {
      sadzba_pozadovana: null,
      sadzba_schvalena: null,
      fix: null,
      suma_nadobudnutie: null,
      suma_refinancovanie: null,
      suma_bezucel: null,
      splatnost: null,
      splatka: null,
      poplatok_za_poskytnutie: null
    },
  }),
}
</script>

<style scoped>
.input-hint {
  color: #728099;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 7px;
}
</style>
